// extracted by mini-css-extract-plugin
export default {"container":"NotificationsModal_container__yuxCy","log":"NotificationsModal_log__s9UgC","time":"NotificationsModal_time__d3cmm"};